(function () {
	if (window.__cottolioRecipeFaqInit) return;
	window.__cottolioRecipeFaqInit = true;

	function initRecipeFaq(root) {
		if (!root || root.dataset.recipeFaqReady === 'true') return;

		const toggle = root.querySelector('[data-recipe-faq-toggle]');
		const items = root.querySelector('[data-recipe-faq-items]');
		if (!toggle || !items) return;

		items.style.display = 'none';
		toggle.setAttribute('aria-expanded', 'false');
		root.classList.remove('recipe-article__faq--open');

		toggle.addEventListener('click', function () {
			const isOpen = root.classList.toggle('recipe-article__faq--open');
			toggle.setAttribute('aria-expanded', String(isOpen));

			if (window.jQuery) {
				window.jQuery(items).stop().slideToggle(300);
			} else {
				items.style.display = isOpen ? 'block' : 'none';
			}
		});

		root.dataset.recipeFaqReady = 'true';
	}

	function initAllRecipeFaqs() {
		document.querySelectorAll('[data-recipe-faq]').forEach(initRecipeFaq);
	}

	document.addEventListener('DOMContentLoaded', initAllRecipeFaqs);
	document.addEventListener('shopify:section:load', initAllRecipeFaqs);
	initAllRecipeFaqs();
})();
